import { render } from "./Text.vue?vue&type=template&id=6db16d54"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"
script.render = render

export default script